import { atom } from 'jotai';
import { focusAtom } from 'jotai-optics';

export const INITIAL_VIDEO_SOURCE_VALUE = { url: '' };
export const selectedVideoSourceAtom = atom(INITIAL_VIDEO_SOURCE_VALUE);
selectedVideoSourceAtom.debugLabel = 'selectedVideoSource';

export const selectedVideoSourceURLAtom = focusAtom(
  selectedVideoSourceAtom,
  (optic) => optic.prop('url'),
);

export const EVENTS = 'events';
export const PLAYS = 'plays';
export const MATCH = 'match';
export const MP4_STRING = 'mp4';
export const STREAM = 'stream';
export const videoTypeAtom = atom(MATCH);
videoTypeAtom.debugLabel = 'videoType';

export const MANUAL = 'manual';
export const VIA_API = 'api';
export const BALL_IN_PLAY = 'bip';
export const MATCH_EVENTS = 'matchEvents';
export const DEFAULT_TIMESTAMP_SELECTION_METHOD = MANUAL;
export const selectedTimestampSelectionMethodAtom = atom(
  DEFAULT_TIMESTAMP_SELECTION_METHOD,
);
selectedTimestampSelectionMethodAtom.debugLabel =
  'selectedTimestampSelectionMethod';

export const sourceToVideoReference = (selectedVideoSource) => ({
  match_id: selectedVideoSource.matchId,
  period: selectedVideoSource.matchPart,
  sport: selectedVideoSource.sport,
  track: selectedVideoSource.track,
  version: selectedVideoSource.version,
});

export const selectedVideoReferenceAtom = atom();
selectedVideoReferenceAtom.debugLabel = 'selectedVideoReference';

export const selectedIdsAtom = atom([]);
selectedIdsAtom.debugLabel = 'selectedIds';

export const addSelectedIdAtom = atom(
  (get) => get(selectedIdsAtom),
  (get, set, newId) => {
    set(selectedIdsAtom, [...get(selectedIdsAtom), newId]);
  },
);
selectedIdsAtom.debugLabel = 'selectedIds';

export default { selectedVideoSourceAtom };
